<template>
  <div class="app-planning">
    <div class="columns">
      <div class="column is-one-quarter">
        <div class="buttons has-addons">
          <span v-for="duree in dureeAffichage" :key="duree.dureeEnMois"
                class="button"
                :class="{ 'is-primary': criterePlanning.months === duree.dureeEnMois }"
                @click="updateDureeEnMois(duree.dureeEnMois)">
            {{ duree.label }}
          </span>
        </div>
      </div>
      <div class="column is-half has-text-centered">
        <div>
          <button class="button" @click="updateDateDebut(-criterePlanning.months)">
            <b-icon icon="chevron-double-left"></b-icon>
          </button>
          <button class="button" @click="updateDateDebut(-1)">
            <b-icon icon="chevron-left"></b-icon>
          </button>
          <span style="min-width: 290px;display: inline-block;">
        {{ dateDebutFormattee }} - {{ dateFinFormattee }}
        </span>
          <button class="button" @click="updateDateDebut(1)">
            <b-icon icon="chevron-right"></b-icon>
          </button>
          <button class="button" @click="updateDateDebut(criterePlanning.months)">
            <b-icon icon="chevron-double-right"></b-icon>
          </button>
        </div>
      </div>
      <div class="column is-one-quarter">
        <div class="is-pulled-right">
          <a class="button" @click="getPlaningPdf()">
            <b-icon icon="printer" ></b-icon>
            <span class="ellipsis btn_consultation">Imprimer</span>
          </a>
        </div>
      </div>
    </div>
    <v-client-table class="fixed_header" ref="planning"
                    :data="reseauxLcWithFilter"
                    :columns="columns"
                    :options="options">
      <div slot="zoom" slot-scope="props" style="text-align:center">
        <a @click="zoomReseau(props.row)">
          <b-icon icon="google-maps" type="is-primary"></b-icon>
        </a>
      </div>
      <div slot="diaporama" slot-scope="props" style="text-align:center">
        <a @click="ouvrirDiaporama(props.row)">
          <b-icon icon="image-multiple" type="is-primary"></b-icon>
        </a>
      </div>
      <div slot="selected" slot-scope="props" style="text-align:center">
        <input type="checkbox" id="checkbox" :value="props.row" v-model="props.row.selected"
               @click="ajoutPanier(props.row)">
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import * as types from '@/store/creationOpportunite/venteReseauxLc-mutation-type';
import PlanningSvg from './planningSvg';

const VenteReseauxLc = createNamespacedHelpers('venteReseauxLc');
const Modal = createNamespacedHelpers('modal');
const User = createNamespacedHelpers('user');

export default {
  name: 'planning',
  data() {
    return {
      dureeAffichage: [
        { dureeEnMois: 3, label: '3 mois' },
        { dureeEnMois: 6, label: '6 mois' },
        { dureeEnMois: 12, label: '12 mois' },
      ],
      trad: {
        Code: '↑↓ Code',
        Libelle: '↑↓ Libelle',
        Ville: '↑↓ Ville',
        Planning: 'Planning',
        zoom: 'Carto',
        diaporama: 'Diapo',
        selected: 'Panier',
      },
    };
  },
  components: {
    appPlanningSvg: PlanningSvg,
  },
  computed: {
    ...VenteReseauxLc.mapGetters({
      reseauxLc: 'reseauxLc',
      reseauxLcWithFilter: 'reseauxLcWithFilter',
      criterePlanning: 'criterePlanning',
      markersReseauxLc: 'markersReseauxLc',
      getActiveTabReseau: 'activeTabReseau',
      getZoomMarker: 'zoomMarker',
    }),
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesReseauSelect: 'facesSelectDiapo',
    }),
    ...User.mapGetters({
      site: 'site',
    }),
    dateDebutFormattee() {
      return this.criterePlanning.dateStart.format('LL');
    },
    dateFinFormattee() {
      return this.criterePlanning.dateEnd.format('LL');
    },
    activeTab: {
      get() {
        return this.getActiveTabReseau;
      },
      set(value) {
        this.setActiveTabReseau(value);
      },
    },
    facesReseauSelectDiapo: {
      get() {
        return this.getFacesReseauSelect;
      },
      set(value) {
        this.setFacesReseauSelect(value);
      },
    },
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
    zoomMarker: {
      get() {
        return this.getZoomMarker;
      },
      set(value) {
        this.setZoomMarker(value);
      },
    },
    columns() {
      return ['selected', 'code', 'libelle', 'ville', 'zoom', 'diaporama', 'planning'];
    },
    options() {
      return {
        headings: {
          selected: this.trad.selected,
          code: this.trad.Code,
          libelle: this.trad.Libelle,
          ville: this.trad.Ville,
          diaporama: this.trad.diaporama,
          zoom: this.trad.zoom,
          planning(h) {
            return this.getPlanningHeader(h);
          },
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        perPage: 500,
        texts: TEXTS,
        templates: {
          planning: PlanningSvg,
        },
        columnsClasses: {
          code: 'ellipsis ventesLcPlanningTailleColonneCode',
          libelle: 'ellipsis ventesLcPlanningTailleColonneCode',
          adresse: 'ellipsis ventesLcPlanningTailleColonneAdresse',
          planning: 'ventesReseauLcPlanningTailleColonnePlanning',
          ville: 'ellipsis ventesLcPlanningTailleColonneVille',
          zoom: 'ventesLcPlanningTailleColonneSelected',
          diaporama: 'ventesLcPlanningTailleColonneSelected',
          selected: 'ventesLcPlanningTailleColonneSelected',
        },
      };
    },
  },
  methods: {
    ...VenteReseauxLc.mapActions({
      actionsChangementDateDebutPlanningLc: 'changementDateDebutPlanningLc',
      actionsPeutAjouterAuPanier: 'peutAjouterAuPanier',
      actionsGestionPanier: 'gestionPanier',
      actionsGetPlanningPdf: 'getPlanningPdf',
    }),
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
      setFacesReseauSelect: typesModal.SET_FACES_SELECT_DIAPO,
    }),
    ...VenteReseauxLc.mapMutations({
      setActiveTabReseau: types.SET_ACTIVE_TAB_RESEAU,
      setZoomMarker: types.SET_ZOOM_MARKER,
    }),
    updateDureeEnMois(duree) {
      this.actionsChangementDateDebutPlanningLc(
        {
          debut: this.criterePlanning.dateStart,
          nombreMois: duree,
        },
      );
    },
    updateDateDebut(decalage) {
      this.actionsChangementDateDebutPlanningLc(
        {
          debut: this.criterePlanning.dateStart.clone().add(decalage, 'M'),
          nombreMois: this.criterePlanning.months,
        },
      );
    },
    getPlanningHeader(h) {
      return h('svg', {
        attrs: {
          width: '100%',
          height: '28px',
        },
      },
      this.getPlanningHeaderMois(h));
    },
    getPlanningHeaderMois(h) {
      const lineAndTextArray = [];
      const nombreJoursTotal = this.criterePlanning.days;
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateEnd;
      let dateVar = dateStart.clone();
      while (dateVar < dateEnd) {
        const offset = dateVar.diff(dateStart, 'days') / nombreJoursTotal * 100;
        if (!dateVar.isSame(dateStart)) {
          lineAndTextArray.push(h('line', {
            attrs: {
              x1: offset + '%',
              y1: '0',
              x2: offset + '%',
              y2: '80%',
              style: 'stroke: #E3E1F2;stroke-width: 2px',
            },
          }));
        }
        lineAndTextArray.push(h('text', {
          attrs: {
            x: (offset + 0.5) + '%',
            y: '50%',
            'dominant-baseline': 'central',
            'text-anchor': 'start',
            'font-size': '12px',
          },
        }, dateVar.format('MMM')));
        dateVar = dateVar.add(1, 'M');
      }
      return lineAndTextArray;
    },
    zoomReseau(reseau) {
      const marker = this.markersReseauxLc.find((el) => {
        return reseau.latitude === el.position.lat && reseau.longitude === el.position.lng;
      });
      this.zoomMarker = marker;
      this.activeTab = 0;
    },
    ouvrirDiaporama(reseau) {
      reseau.listeFaces.forEach((el) => {
        el.libelleReseau = reseau.libelle;
      });
      this.facesReseauSelectDiapo = reseau.listeFaces;
      this.isComponentDiaporama = true;
    },
    ajoutPanier(reseau) {
      if (!this.actionsPeutAjouterAuPanier) {
        return;
      }
      this.actionsGestionPanier(reseau.num);
    },
    async getPlaningPdf() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const listesResNums = this.$refs.planning.filteredData.map(el => el.num);
      try {
        await this.actionsGetPlanningPdf(listesResNums);
        loadingComponent.close();
        return true;
      } catch (error) {
        loadingComponent.close();
        return false;
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxLc/recherche/planning.vue